import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';
import ProductItemProps from 'types/components/ProductItemProps';
import useMediumScreen from 'hooks/useMediumScreen';
import { styles } from 'styles/components/productItem';

export default ({
  product,
  onChangeQuantity,
  setShoppingCart,
  shoppingCart,
  generalColor,
}: ProductItemProps): JSX.Element => {
  const medium = useMediumScreen();
  const [productQuantity, setQuantity] = React.useState<number>(0);

  const onClickAdd = () => {
    const newQuantity = productQuantity + 1;
    if (newQuantity === 1) {
      const currentShoppingCart = shoppingCart;
      if (currentShoppingCart) {
        const detailItem = currentShoppingCart.detail.find((item) => item.product.id === product.id);
        if (!detailItem) {
          currentShoppingCart.detail.push({ product: product, quantity: 1 });
          setShoppingCart({ ...currentShoppingCart });
        }
      }
    }
    setQuantity(newQuantity);
    if (onChangeQuantity) onChangeQuantity(product.id, newQuantity);
  };

  const onClickRemove = () => {
    if (productQuantity > 1 || productQuantity === 1) {
      const newQuantity = productQuantity - 1;
      setQuantity(newQuantity);
      if (newQuantity === 0) {
        if (shoppingCart) {
          shoppingCart.detail = shoppingCart.detail.filter((item) => item.product.id !== product.id);
          setShoppingCart({ ...shoppingCart });
        }
      }
      if (onChangeQuantity) onChangeQuantity(product.id, newQuantity);
    }
  };

  const renderControlQuantity = () => {
    return (
      <View style={styles.controlQuantityContainer}>
        <Icon
          name="chevron-left"
          type="entypo"
          color={generalColor}
          onPress={() => onClickRemove()}
          disabled={!product.stock}
          disabledStyle={styles.disabledIconStyle}
          containerStyle={styles.containerIcon}
          iconStyle={styles.iconDefault}
          size={medium ? 35 : 30}
        />
        <View style={medium ? styles.productQuantityContainerLarge : styles.productQuantityContainerSmall}>
          <Text style={[styles.productQuantity, { color: generalColor }]}>{productQuantity}</Text>
        </View>
        <Icon
          name="chevron-right"
          type="entypo"
          color={generalColor}
          onPress={() => onClickAdd()}
          disabled={!product.stock}
          disabledStyle={styles.disabledIconStyle}
          containerStyle={styles.containerIcon}
          iconStyle={styles.iconDefault}
          size={medium ? 35 : 30}
        />
      </View>
    );
  };

  return (
    <TouchableOpacity
      key={product.id}
      disabled={!product.stock}
      style={{ opacity: product.stock ? 1.0 : 0.5 }}
      onPress={() => onClickAdd()}
    >
      <View style={medium ? styles.cardItemLarge : styles.cardItemSmall}>
        <View style={styles.productNameContainer}>
          <Text style={styles.textProductName}>{product.name}</Text>
        </View>
        {renderControlQuantity()}
      </View>
      {!product.stock && <Text style={styles.noStockMessage}>Sin Stock</Text>}
    </TouchableOpacity>
  );
};
